<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <BaseFieldString
            v-model="currentItem.queue_name"
            label="Queue name"
            class="mt-3"
        ></BaseFieldString>
        <BaseFieldString
            v-model="currentItem.printer_name"
            label="Printer name"
            class="mt-3"
        ></BaseFieldString>
        <BaseFieldString
            v-model="currentItem.label"
            label="Label"
            class="mt-3"
        ></BaseFieldString>
        <BaseFieldCheck
            v-model="currentItem.executed"
            label="Executed"
            class="mt-3"
        ></BaseFieldCheck>
        <BaseFieldText
            v-model="currentItem.data"
            label="data"
            class="mt-3"
        ></BaseFieldText>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import BaseFieldText from "@/components/Base/BaseFieldText";

export default {
  name: "PrinterQueueDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'PrinterQueueDetail'},
    dtoDetailQuery: {default: 'PrinterQueueDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'PrinterQueueActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'PrinterQueueSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'PrinterQueueValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'PrinterQueueBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'PrinterQueueTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldText,
    BaseFieldCheck,
    BaseFieldString,
    CommonDetail,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
  },

  methods: {
  }
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>